<template>
  <div class="body1">
    <div class="content">
      <div class="title">APPLICATION</div>
      <div class="list-box">
        <div class="item">
          <P class="tit-p">Which country / city would you like to franchise?</P>
          <div class="inp-box">
            <el-select style="width: 100%;" placeholder="Please select" v-model="inpData.countryId" size="small" clearable>
              <el-option v-for="item in countryData"
                  :key="item.id"
                  :label="item.countryNameEn"
                  :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="item-box">
          <div class="item">
            <P class="tit-p">Name</P>
            <div class="inp-box">
              <el-input :maxlength="50" v-model="inpData.name" size="small"></el-input>
            </div>
          </div>
          <div class="item">
            <P class="tit-p not-tit">City</P>
            <div class="inp-box">
              <el-input :maxlength="50" v-model="inpData.city" size="small"></el-input>
            </div>
          </div>
        </div>
        <div class="item-box">
          <div class="item">
            <P class="tit-p">Email</P>
            <div class="inp-box">
              <el-input :maxlength="50" v-model="inpData.email" size="small"></el-input>
            </div>
          </div>
          <div class="item">
            <P class="tit-p">Primary Phone Number</P>
            <div class="inp-box">
              <el-input :maxlength="50" v-model="inpData.phone" size="small"></el-input>
            </div>
          </div>
        </div>
        <div class="item diff-item">
          <P class="tit-p not-tit">Questions or Comments</P>
          <div class="inp-box">
            <el-input :maxlength="500" class="textarea-input" type="textarea" v-model="inpData.comments"></el-input>
          </div>
        </div>
      </div>
      <div @click="submitFun()" class="submit-btn">Submit To</div>
    </div>
  </div>
</template>

<script>
  import {submitFun, countryList} from "../../request/api/submit";
  import {Debounce} from "../../utils/debounce";
export default {
  data() {
    return {
      inpData:{
        countryId:'',
        name:'',
        email:'',
        phone:'',
        city:'',
        comments:''
      },
      countryData:[]
    }
  },
  mounted() {
    this.countryList()
  },
  methods: {
    // 获取国家列表
    countryList(){
      countryList().then(res => {
        this.countryData = res.data;
      });
    },
    // 提交表单
    submitFun:Debounce(function() {
      let warnStr = this.inpData.countryId==''?'Please select a country':
      this.inpData.name==''?'Please enter your name':
      this.inpData.email==''?'Please enter your email address':
      this.inpData.phone==''?'Please enter a phone number':'';
      if(warnStr!=''){
        this.$message.warning(warnStr);
        return false;
      };
      submitFun({
        countryId:this.inpData.countryId,
        name:this.inpData.name,
        email:this.inpData.email,
        phone:this.inpData.phone,
        city:this.inpData.city,
        comments:this.inpData.comments,
      }).then(res => {
        if(res.code==200){
          this.$message.success('提交成功');
          this.inpData.countryId = '';
          this.inpData.name = '';
          this.inpData.email = '';
          this.inpData.phone = '';
          this.inpData.city = '';
          this.inpData.comments = '';
        }else{
          this.$message.error(res.msg);
        };
      });
    },1000)
  }
}
</script>

<style scoped lang="less">
@import "../../assets/style/index";
.body1{
  height: 786px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #6D43A1;
  position: relative;
  .content{
    .media-content;
    max-width: 1000px;
    box-sizing: border-box;
    padding: 42px 72px 60px;
    border-radius: 25px 25px 0 0;
    background: rgba(244, 235, 255, 0.98);
    .img{
      width: 637px;
      object-fit: contain;
      height: 357px;
      margin-right: 50px;
    }
    .title{
      color: #6D43A1;
      font-size: 40px;
      font-weight: bold;
      text-align: center;
      margin-bottom: 42px;
      font-family: 'Adobe Heiti Std', Helvetica, Arial, sans-serif;
    }
    .list-box{
      .item{
        display: block;
        margin-top: 20px;
        .tit-p{
          position: relative;
          width: 100%;
          text-align: left;
          color: #000000;
          font-size: 14px;
          padding-left: 8px;
        }
        .tit-p::before{
          content: '*';
          display: block;
          width: 5px;
          height: 5px;
          color: #FF0000;
          position: absolute;
          top: 0;
          left: 0px;
        }
        .tit-p.not-tit{
          padding-left: 2px;
        }
        .tit-p.not-tit::before{
          display: none;
        }
        .inp-box{
          width: 100%;
        }
      }
      .item-box{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .item{
          width: 48%;
        }
      }
      .diff-item {
        margin-top: 32px;
      }
      .diff-item .inp-box{
        height: 125px;
      }
    }
    .submit-btn{
      width: 418px;
      height: 52px;
      line-height: 52px;
      text-align: center;
      color: #FFFFFF;
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;
      margin: 42px auto 0;
      border-radius: 10px;
      background: #6D43A1;
    }
  }
  /deep/ .el-input--small .el-input__inner{
    border: none;
    height: 52px !important;
    line-height: 52px;
  }
  /deep/ .el-textarea__inner{
    border: none;
    width: 100%;
    height: 125px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/franchise/e-body5.vue